import { ScrollSpyTargetFactory } from "./targets/_factory"

class ScrollSpy{
    static instance
    static getInstance(...args){
        if(! this.instance){
            this.initInstance(...args)
        }
        return this.instance
    }
    static initInstance(...args){
        this.instance = new this(...args)
    }
    constructor(){
        this.is_inited = false
        this.targets = []
        this.initActions()
    }
    initActions(){
        if(! this.is_inited){
            window.addEventListener('scroll', this.handleScrollEvent.bind(this))
            window.addEventListener('resize', this.handleResizeEvent.bind(this))
            this.is_inited = true
        }
    }
    handleScrollEvent(event){
        for(const target of this.targets){
            target.onScroll(event)
        }
    }
    handleResizeEvent(event){
        for(const target of this.targets){
            target.onResize(event)
        }
    }
    registerTarget(element, config = {}){
        const target = ScrollSpyTargetFactory
                .factory(element, config)
        this.targets.push(target)
        target.onScroll()
    }
}

export {
    ScrollSpy,
}